// Entitycore
import { PlanBuilder } from "../../legacyPlanner/plan/PlanBuilder";
import { PlanContext } from "../../legacyPlanner/plan/PlanContext";
/** Class to handle serialization/deserialization for plan */ export class PlanSerializationHandler {
    /** serialize to IGraphPlanResource */ toSerializable(key, value) {
        const createdBy = value.createdBy || value.createdByAppId ? {
            user: value.createdBy ? {
                displayName: null,
                id: value.createdBy
            } : undefined,
            application: value.createdByAppId ? {
                displayName: null,
                id: value.createdByAppId
            } : undefined
        } : undefined;
        return {
            ...value.toGraphSerializable(),
            isArchived: value.isArchived,
            archivalInfo: value.archivalInfo ? value.archivalInfo.toGraphSerializable() : null,
            createdDateTime: value.createdDate,
            createdBy: createdBy,
            deletedBy: value.deletedBy ? {
                user: {
                    displayName: null,
                    id: value.deletedBy
                }
            } : undefined,
            contexts: PlanContext.getGraphContextResourcesForPersistence(value.contexts),
            contentSensitivityLabelAssignment: value.contentSensitivityLabelAssignment
        };
    }
    /** build IPlan from IGraphPlanResource */ fromSerializable(key, serializableValue) {
        return new PlanBuilder().fromGraphResource(serializableValue).build();
    }
}
